// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2ficr","approved":"Status_approved__3Hqz9","rejected":"Status_rejected__3-lw5","expired":"Status_expired__3KAXI","label":"Status_label__MT81y"};